module.exports = __webpack_public_path__ + "static/img/a3.80c7961.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/a3.png
// module id = 27
// module chunks = 1